import { API_BASE_URL, ACCESS_TOKEN } from '../constants/index.js';
import { jsonSuccessFailureRequest, formSuccessFailureRequest } from './APIUtils.js';


export function getClustererPrototypesByUser(datasetId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var rq = (datasetId ? '?datasetId=' + datasetId : '');

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/get-all-my" + rq,
    method: 'GET',
  })
}

export function getClustererPrototypes(datasetId, projectId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var rq = (datasetId ? '?datasetId=' + datasetId : '');
  rq += (projectId ? '?projectId=' + projectId : ''); // cannot have both project and dataset !!!

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/get-all" + rq,
    method: 'GET',
  })
}

export function getClustererPrototype(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/get/" + id,
    method: 'GET'
  })
}

export function updateClustererPrototype(id, name, identifier, description, schemaDatasetId, element, keysMetadata, computation) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var body = { name, identifier, schemaDatasetId, structure: {element, keysMetadata}, computation }
   if (description) {
      body = { ...body, description }
    }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/update/" + id,
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function createClustererPrototype(name, datasetId, identifier, description, schemaDatasetId, element, keysMetadata, computation) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var body = { name, identifier, schemaDatasetId, structure: {element, keysMetadata}, computation }
  if (description) {
     body = { ...body, description }
   }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/new?datasetId=" + datasetId,
    method: 'POST',
    body:  JSON.stringify(body),
  })
}

export function deleteClustererPrototype(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/delete/" + id,
    method: 'DELETE'
  });

}

export function checkClustererPrototypeIdentifier(identifier) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer-prototype/exists-identifier?identifier=" + encodeURIComponent(identifier),
    method: 'GET'
  })
}
